import Grid from '@components/grid';
import Button from '@components/ui/button';
import Divider from '@blocks/Divider';
import Text from '@components/ui/text';
import { motion } from 'framer-motion';
import Image from 'next/image';
import React, { ReactElement } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import { Post, Category } from '@payload/types';

interface Props {
  article: Post;
  hasDownload: boolean;
  downloadClick: () => void;
}
export default function ArticleHero({
  article,
  hasDownload,
  downloadClick,
}: Props): ReactElement {
  //@ts-ignore
  const category: Category = article?.category;
  return (
    <Grid className="grid-rows-2 grid-rows-max lg:grid-rows-1 gap-0 lg:gap-8 md:h-auto bg-accent-1">
      <div className="col-span-full lg:col-span-6 xl:col-span-7 p-8 md:p-14 md:py-18 lg:p-20 lg:py-28  flex flex-col justify-center items-center relative">
        <div className="max-w-2xl">
          <h5 className="uppercase mb-2 text-sm">{category?.title}</h5>
          <Text className="mb-2 lg:mb-8" variant="pageHeading">
            {article?.title}
          </Text>
          <Text>{article?.summary}</Text>
          {hasDownload && (
            <>
              <Divider />
              <Button
                type="button"
                variant="cta"
                className=""
                onClick={downloadClick}
              >
                Download
              </Button>
            </>
          )}
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="col-span-full lg:col-span-6 xl:col-span-5 overflow-hidden relative bg-black"
      >
        <Image
          //@ts-ignore
          src={`${process.env.NEXT_PUBLIC_ASSET_URL}/${article?.image?.sizes?.post?.filename}`}
          layout="fill"
          quality={100}
          priority
          //@ts-ignore
          alt={''}
          className="absolute inset-0 object-cover object-center"
        />
        <div className="flex items-center w-full absolute bottom-0 right-0 z-10">
          <button
            type="button"
            onClick={() =>
              document
                .getElementById('article')!
                .scrollIntoView({ behavior: 'smooth' })
            }
            aria-label="prev-button"
            className="absolute bottom-0 right-0 bg-opacity-90 hover:bg-opacity-100 transition-all duration-300 text-xl lg:text-2xl h-16 w-16 lg:h-20 lg:w-20 bg-telesoft text-heading flex justify-center items-center"
          >
            <BsChevronDown className="animate-bounce mt-4" />
          </button>
        </div>
      </motion.div>
    </Grid>
  );
}
